<template>
  <div class="parsing">
    <div class="tit jf">
      <div class="cyc"></div>
      <div class="text c-72777F">解析</div>
    </div>
    <div>
      <div class="text" v-if="analysis" v-html="analysis"></div>
      <div v-else class="text">暂无解析</div>
    </div>
  </div>
</template>
<script>
export default {
    name: "AnswerParser",
    props: {
        analysis: {
            type: String
        }
    }
}
</script>
<style scoped lang="less">
.parsing {
    .tit {
        margin: 30px 0 20px 0;

        .cyc {
            width: 5px;
            height: 5px;
            border-radius: 50%;
            background: #256CF4;
            margin-right: 8px;
        }
    }
}
</style>
